import React from 'react';
import { Modal } from './Modal';

// Confirmation for destructive or hard-to-undo actions.
export const ConfirmDialog = ({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'default',
  onConfirm,
  onCancel
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onCancel}
    title={title}
    size="small"
    role="alertdialog"
    footer={
      <div className="form-buttons">
        <button type="button" className="btn-secondary" onClick={onCancel} data-autofocus>
          {cancelLabel}
        </button>
        <button type="button" className={tone === 'danger' ? 'btn-danger' : 'btn-primary'} onClick={onConfirm}>
          {confirmLabel}
        </button>
      </div>
    }
  >
    <p className="confirm-message">{message}</p>
  </Modal>
);
